import React, { useContext } from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails, Button } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import moment from 'moment'
import { DailyMonitoringDetailsFiltersContext } from '../../../../context/DailyMonitoringDetailsFiltersContext'
import { LayoutContext } from '../../../../context/LayoutContext'
import YearFilter from './Year'
import MonthFilter from './Month'
import StatesFilter from './States'
import CitiesFilter from './Cities'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    item: {
      marginBottom: theme.spacing(2)
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'left',
      color: theme.palette.text.primary
    },
    container: {
      display: 'flex',
      justifyContent: 'flex-start'
    }
  })
)

export default function Filters (): JSX.Element {
  const classes = useStyles()
  const { setFilters } = useContext(DailyMonitoringDetailsFiltersContext)
  const { layout, setLayout } = useContext(LayoutContext)

  const handleChange = (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setLayout({
      isFilterOpen: isExpanded
    })
  }

  const cleanHandler = () => {
    setFilters({
      date: {
        year: +moment().year(),
        month: +moment().month() + 1,
        time_zone: '-03:00'
      },
      states: [],
      cities: []
    })
  }

  return (
    <div className={classes.root}>
      <Accordion className={classes.paper} expanded={layout.isFilterOpen} onChange={handleChange}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography paragraph>Filtros</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={1} className={classes.container}>
          <Grid item container spacing={2} justifyContent="space-between" className={classes.item}>
              <Grid item sm={12} md={6}>
                <YearFilter />
              </Grid>
              <Grid item sm={12} md={5}>
                <MonthFilter />
              </Grid>
            </Grid>
            <Grid item container spacing={2} justifyContent="space-between" className={classes.item}>
              <Grid item sm={12} md={6}>
                <StatesFilter />
              </Grid>
              <Grid item sm={12} md={5}>
                <CitiesFilter />
              </Grid>
            </Grid>
            <Grid item container spacing={2} justifyContent="flex-end" className={classes.item}>
              <Button color="secondary" onClick={cleanHandler}>limpar</Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
